import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import RequestServies from "../../../services/RequestServies";
import ProductServices from "../../../services/ProductServices";
import RequisitionForm from "../Requisition/RequisitionNumberModal";
import RepairServices from "../../../services/RepairServices";
import AddMrvForm from "./AddMrvForm";
import Swal from 'sweetalert2';

const RepairPoOrders = ({ onSuccess }) => {
  // Part numbers allowed to receive more than approved qty
  const ALLOWED_EXCESS_PARTS = [
    '20634', '20635', '20636', '20637', '20638',
    '20639', '21766', '23470', '23471', '23472'
  ];

  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState();
  const [selectedSupplier, setSelectedSupplier] = useState('');

  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  const [stores, setStores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);

  const [mrv, setMrv] = useState([]);
  const [selectedMrv, setSelectedMrv] = useState("");
  const [run, setRun] = useState(0);

  const [items, setItems] = useState([
    { name: "", id: "", description: "", approveQty: 0, qtyRequired: 0, recivedQty: 0, damageQty: 0, error: "", unit: "", remark: "" },
  ]);
  const [partOptions, setPartOptions] = useState([]);

  const handleAddItem = (e) => {
    e.preventDefault();
    const lastItem = items[items.length - 1];

    // Check for required fields
    if (
      !lastItem ||
      !lastItem.id ||
      !lastItem.partNo ||
      lastItem.recivedQty <= 0
    ) {
      Swal.fire({
        icon: 'warning',
        title: 'Incomplete Item',
        text: 'Please select item and enter received quantity.',
      });
      return;
    }



    setItems([
      ...items,
      { name: "", id: "", description: "", approveQty: 0, qtyRequired: 0, recivedQty: 0, damageQty: 0, error: "", unit: "" },
    ]);
  };

  const handleItemChange = (index, field, value) => {
    const numericValue = (field === "recivedQty" || field === "damageQty") ? parseFloat(value) : value;
    const newItems = [...items];
    newItems[index][field] = numericValue;

    if (field === "recivedQty") {
      const partNo = newItems[index].partNo?.toString();
      const approveQty = newItems[index].approveQty;
      const damageQty = newItems[index].damageQty || 0;
      let maxEligibleQty = approveQty - damageQty;

      if (ALLOWED_EXCESS_PARTS.includes(partNo)) {
        maxEligibleQty = approveQty + (approveQty * 0.05);
      }

      if (numericValue > maxEligibleQty) {
        newItems[index].error = `Received Qty cannot exceed ${maxEligibleQty.toFixed(2)} for this item.`;
      } else if (numericValue < 0) {
        newItems[index].error = `Received Qty cannot be 0 or negative`;
      } else {
        newItems[index].error = "";
      }
    }

    if (field === "damageQty") {
      if (numericValue > newItems[index].approveQty - newItems[index].recivedQty) {
        newItems[index].error = `Damage Qty cannot be greater than Approve Qty`;
      } else if (numericValue < 0) {
        newItems[index].error = `Damage Qty cannot be 0 or negative`;
      } else {
        newItems[index].error = "";
      }
    }

    setItems(newItems);
  };

  const handlePartSelect = (index, selectedOption) => {
    const isDuplicate = items.some(item => item.id === selectedOption.value);
    if (isDuplicate) {
      Swal.fire({
        icon: 'error',
        title: 'Duplicate Item',
        text: 'This item has already been added.'
      });
      return;
    }

    handleItemChange(index, "id", selectedOption.value);
    handleItemChange(index, "partNo", selectedOption.partNo);
    handleItemChange(index, "description", selectedOption.description);
    handleItemChange(index, "unit", selectedOption.unit);
    handleItemChange(index, "approveQty", selectedOption.approveQty);
    handleItemChange(index, "qtyRequired", selectedOption.qtyRequired);
    handleItemChange(index, "poNumber", selectedOption.poNumber);
    handleItemChange(index, "supplierName", selectedOption.supplierName);
  };


  const handleRemoveItem = (e, index) => {
    e.preventDefault();
    const newItems = [...items];
    newItems.splice(index, 1);
    setItems(newItems);
  };
  useEffect(() => {
    if (!selectedStore) return;

    setItems([
      { name: "", id: "", description: "", approveQty: 0, qtyRequired: 0, recivedQty: 0, damageQty: 0, error: "", unit: "" }
    ]);

    RepairServices.getMrv(selectedStore)
      .then((res) => {
        const allMrv = res?.data?.data || [];

        const validMrvs = allMrv.filter(
          mrv => mrv?.supplier && !mrv?.supplier?.name?.toLowerCase().startsWith("local")
        );

        setMrv(validMrvs);

        if (validMrvs.length > 0) {
          const first = validMrvs[0];
          setSelectedMrv(first._id);
          setSelectedSupplier(first.supplier?._id);
          console.log("selectmrv", first._id)
          console.log("selectedsupplier", first.supplier?._id)
        } else {
          setSelectedMrv(null);
          setSelectedSupplier(null);
        }
      })
      .catch(console.error);

  }, [selectedStore, run]);


  useEffect(() => {
    if (!selectedStore || !selectedMrv) return;

    const status = 'approved';
    const poStatus = 'generated';

    RepairServices.getAllItem(undefined, status, selectedStore, poStatus)
      .then((res) => {
        console.log("datapii", res?.data?.data)
        const filtered = res?.data?.data?.filter(
          item => item?.po?.supplier?._id === selectedSupplier
        );

        console.log("datapiifliterd", filtered)

        const options = filtered.map(item => ({
          value: item._id,
          partNo: item.masterlist?.partNo,
          description: item.masterlist?.description,
          unit: item.masterlist?.unit?.name,
          approveQty: item?.approveQty,
          qtyRequired: item?.qtyRequired,
          poNumber: item?.po?.poNumber,
          supplierName: item?.po?.supplier?.name,
        }));

        setPartOptions(options);
      })
      .catch(console.error);

  }, [selectedStore, selectedMrv, run]);


  const handleSubmit = (e) => {
    e.preventDefault();

    let isValid = true;
    let errorMessage = "";

    // ✅ Prevent duplicate items on submission
    const uniqueIds = new Set();
    for (const item of items) {
      if (uniqueIds.has(item.id)) {
        isValid = false;
        errorMessage = `Duplicate item detected: ${item.name || item.id}`;
        break;
      }
      uniqueIds.add(item.id);
    }

    if (isValid) {
      items.forEach((item, index) => {
        const approveQty = item.approveQty;
        const receivedQty = item.recivedQty;
        const damageQty = item.damageQty || 0;
        const partNo = item.partNo?.toString();

        let maxEligibleQty = approveQty - damageQty;
        if (ALLOWED_EXCESS_PARTS.includes(partNo)) {
          maxEligibleQty = approveQty + (approveQty * 0.05);
        }

        if (receivedQty > maxEligibleQty) {
          isValid = false;
          errorMessage = `Item ${index + 1} (${partNo}): Received Qty (${receivedQty}) cannot exceed ${maxEligibleQty.toFixed(2)}.`;
        } else if (receivedQty < 0) {
          isValid = false;
          errorMessage = `Item ${index + 1}: Received Qty cannot be negative.`;
        } else if (damageQty > approveQty) {
          isValid = false;
          errorMessage = `Item ${index + 1}: Damage Qty cannot exceed Approved Qty.`;
        } else if (!selectedMrv) {
          isValid = false;
          errorMessage = "MRV Not Selected!";
        }
      });
    }

    if (!isValid) {
      Swal.fire({
        title: 'Error!',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'OK'
      });
      return;
    }

    const requestData = { mrvId: selectedMrv, items };

    RepairServices.submitMrv(requestData)
      .then((response) => {
        Swal.fire({
          title: 'Success!',
          text: 'Order has been Received Successfully',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        setItems([{ name: "", id: "", description: "", approveQty: 0, qtyRequired: 0, recivedQty: 0, damageQty: 0, error: "", unit: "", remark: "" }]);
        setRun(run + 1);
      })
      .catch((error) => {
        console.log('Error during submission:', error);
        Swal.fire({
          title: 'Error!',
          text: 'Error during submission',
          icon: 'error',
          confirmButtonText: 'Retry',
        });
      });
  };

  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
    setSelectedMrv();
  };

  const handleRequisitionForm = () => {
    setIsModelOpen(true);
  };

  const handleMrv = (e) => {
    const mrvId = e.target.value || '';
    const supplierId = e.target.selectedOptions[0].getAttribute('data-supplier');
    setSelectedMrv(mrvId);
    setSelectedSupplier(supplierId);
    setItems([{ name: "", id: "", description: "", approveQty: 0, qtyRequired: 0, recivedQty: 0, damageQty: 0, error: "", unit: "" }]);
    setPartOptions([]);
  };

  useEffect(() => {
    setPartOptions([]);
  }, [selectedMrv]);

  return (
    <>
      <AddMrvForm
        show={isModelOpen}
        handleClose={() => setIsModelOpen(false)}
        store={stores}
        onSuccess={() => setRun(prev => prev + 1)}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    {/* Store Dropdown */}
                    <div className="col-xl-4 col-xxl-4">
                      <label>Select Store</label>

                      <Select
                        className="mb-xl-0 mb-3"
                        options={stores.map((s) => ({
                          value: s._id,
                          label: s.name,
                        }))}
                        value={
                          stores
                            .map((s) => ({
                              value: s._id,
                              label: s.name,
                            }))
                            .find((opt) => opt.value === selectedStore) || null
                        }
                        onChange={(selected) =>
                          setSelectedStore(selected ? selected.value : "")
                        }
                        placeholder="Search Store..."
                        noOptionsMessage={() => "No stores found"}
                        isSearchable
                      />
                    </div>

                    {/* MRV Dropdown */}
                    <div className="col-xl-4 col-xxl-4">
                      <label>Select MRV No.</label>

                      <Select
                        className="mb-xl-0 mb-3"
                        options={
                          mrv.length > 0
                            ? mrv.map((m) => ({
                              value: m._id,
                              label: `${m.repairMrvNo} | ${m.supplier?.name || ""}`,
                              supplierId: m.supplier?._id,
                            }))
                            : []
                        }
                        value={
                          mrv
                            .map((m) => ({
                              value: m._id,
                              label: `${m.repairMrvNo} | ${m.supplier?.name || ""}`,
                              supplierId: m.supplier?._id,
                            }))
                            .find((opt) => opt.value === selectedMrv) || null
                        }
                        onChange={(selected) =>
                          handleMrv({
                            target: {
                              value: selected ? selected.value : "",
                            },
                          })
                        }
                        placeholder="Search MRV No..."
                        noOptionsMessage={() => "No records found"}
                        isSearchable
                      />
                    </div>

                    <div className="col-xl-4 col-xxl-4">
                      <button className="btn btn-sm btn-primary mt-4 w-100" onClick={handleRequisitionForm}>
                        Generate New MRV No
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </Collapse>
          </div>
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fa fa-plus me-2" aria-hidden="true"></i>Add
                MRV Item
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <div
                      id="content_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <form>
                        {items.map((item, index) => (
                          <div key={index} className="row">
                            <div className="form-group mb-2 col-md-3">
                              <label>Select PartNo</label>
                              <Select
                                options={partOptions}
                                value={partOptions.find(opt => opt.value === items[index]?.id) || null}
                                onChange={(selectedOption) => handlePartSelect(index, selectedOption)}
                                getOptionLabel={(option) =>
                                  `${option.partNo} | ${option.description}`
                                }
                                getOptionValue={(option) => option.value}
                                placeholder="Select Part"
                                menuPortalTarget={document.body}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minWidth: 90,
                                    height: 14,
                                    fontSize: '12px',
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    height: '100%',
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    height: 'auto',
                                  }),
                                }}
                              />
                            </div>


                            <div className="form-group mb-2 col-md-2">
                              <label>Description</label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                name="description"
                                value={item.description || ''}
                                placeholder="Description"
                              />
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>
                                {item.unit ? `Sent Qty (${item.unit})` : `Sent Qty`}
                              </label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="qtyRequired"
                                value={item.qtyRequired || 0}
                                placeholder="Required Qty"
                                readOnly
                              />

                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>
                                {item.unit ? `Approved (${item.unit})` : `Approved`}
                              </label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="approveQty"
                                value={item.approveQty || 0}
                                placeholder="approveQty"
                                readOnly
                              />
                            </div>

                            <div className="form-group mb-2 col-md-2">
                              <label>
                                {item.unit ? `Received Qty (${item.unit})` : `Received Qty`}
                              </label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="recivedQty"
                                value={item.recivedQty || 0}
                                onChange={(event) =>
                                  handleItemChange(
                                    index,
                                    "recivedQty",
                                    event.target.value
                                  )
                                }
                                placeholder="recivedQty"
                              />
                              {item.error && <p className="text-danger mb-0">{item.error}</p>}
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>
                                {item.unit ? `Damage (${item.unit})` : `Damage`}
                              </label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="damageQty"
                                value={item.damageQty || 0}
                                onChange={(event) =>
                                  handleItemChange(
                                    index,
                                    "damageQty",
                                    event.target.value
                                  )
                                }
                                placeholder="Damage Qty"
                              />
                              <p className="text-danger">{item.error}</p>
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>PO Number</label>
                              <input type="text" className="form-control form-control-sm" value={item?.poNumber || ''} readOnly />
                            </div>

                            <div className="form-group mb-2 col-md-2">
                              <label>Supplier</label>
                              <input type="text" className="form-control form-control-sm" value={item?.supplierName || ''} readOnly />
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>Remark</label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                name="remark"
                                value={item.remark || ''}
                                onChange={(event) =>
                                  handleItemChange(index, "remark", event.target.value)
                                }
                                placeholder="Remark"
                              />
                            </div>


                            <div className="form-group mb-1 col-md-1">

                              <button className="btn btn-danger btn-xs sharp mt-1"
                                onClick={(e) => handleRemoveItem(e, index)}
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        ))}
                        <div className="row">
                          <div className="form-group mb-2 col-md-2">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={(e) => handleAddItem(e)}
                            >
                              Add Item
                            </button>
                          </div>

                          <div className="form-group mb-2 col-md-2">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={handleSubmit}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3"></div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default RepairPoOrders;
